module.exports = __webpack_public_path__ + "img/screenShow2.f5f2e0f.png";